import React from 'react';
import { Box, Button, Container, Grid, Typography } from '@material-ui/core';
import { homePageStyle } from './home-page.style';
import { homePageContent as content } from './home-page-content.js';
import useIsGuest from '../../../Hook/useIsGuest';
import { SubscribeAlert } from '../subscribeAlert';
import { SubscribeError } from '../subscribeError';
import { useHistory } from 'react-router-dom';

export const HomePage = () => {
  useIsGuest();
  const classes = homePageStyle();
  const history = useHistory();

  return (
    <Container className={classes.container}>
      <SubscribeAlert />
      <SubscribeError />
      {/* header */}
      <Grid
        container
        spacing={0}
        alignItems='center'
        justifyContent='space-between'
        style={{ overflow: 'scroll' }}
        onScroll={(e) => console.log('e', e)}
      >
        <Grid item xs={12} sm={6} md={5} className={classes.section0_box}>
          <Typography variant='h1' className={classes.section0_title}>
            Any time,
            <br /> Anywhere,
            <br /> Together forever
          </Typography>
          <Typography className={classes.section0_description}>
            {content.section0.description}
          </Typography>
          <Box mt={2} display='flex' justifyContent='space-between' width={170}>
            <Button
              variant='outlined'
              color='primary'
              onClick={() => history.push('/signin')}
            >
              sign in
            </Button>
            <Button
              variant='contained'
              color='primary'
              onClick={() => history.push('/signup')}
            >
              sign up
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6} className={classes.image}>
          <img
            src={content.section0.image}
            alt='team members'
            className={classes.section0_image}
          />
        </Grid>
      </Grid>
      {/* =============================================================================== */}
      <Box className={classes.mizbanWorkContainer}>
        <Box className={classes.mizbanWork}>
          <Typography variant='h2' className={classes.mizbanWorkTitle}>
            How Mizban works
          </Typography>
        </Box>
      </Box>
      {/* =============================================================================== */}
      <Grid
        container
        className={classes.section1}
        spacing={0}
        justifyContent='space-between'
      >
        <Grid item xs={12} sm={6} md={7}>
          <Typography variant='h2' className={classes.section1_title}>
            {content.section1.title}
          </Typography>
          <Typography className={classes.section1_description}>
            {content.section1.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.image}>
          <img
            src={content.section1.image}
            alt='team members'
            className={classes.section1_image}
          />
        </Grid>
      </Grid>
      {/* =============================================================================== */}
      <Grid
        container
        className={classes.section2}
        spacing={0}
        justifyContent='space-between'
      >
        <Grid item xs={12} sm={6} md={7}>
          <Typography variant='h2' className={classes.section1_title}>
            {content.section2.title}
          </Typography>
          <Typography className={classes.section1_description}>
            {content.section2.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.image}>
          <img
            src={content.section2.image}
            alt='team members'
            className={classes.section1_image}
          />
        </Grid>
      </Grid>
      {/* =============================================================================== */}
      <Grid
        container
        className={classes.section3}
        spacing={0}
        justifyContent='space-between'
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={7}
          spacing={0}
          justifyContent='space-between'
        >
          <Typography variant='h2' className={classes.section1_title}>
            {content.section3.title}
          </Typography>
          <Typography className={classes.section1_description}>
            {content.section3.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.image}>
          <img
            src={content.section3.image}
            alt='team members'
            className={classes.section3_image}
          />
        </Grid>
      </Grid>
      {/* =============================================================================== */}
      <Grid
        container
        className={classes.section4}
        spacing={0}
        justifyContent='space-between'
      >
        <Grid item xs={12} sm={6} md={7}>
          <Typography variant='h1' className={classes.section1_title}>
            {content.section4.title}
          </Typography>
          <Typography className={classes.section1_description}>
            {content.section4.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} className={classes.image}>
          <img
            src={content.section4.image}
            alt='team members'
            className={classes.section1_image}
          />
        </Grid>
      </Grid>
    </Container>
  );
};
